import React, { useContext } from 'react';
import InputField from '../../../../Components/InputField';
import { Card, CardBody } from '../../../../Components/Card';
import { UserContext } from '../../../../Context/UserContext';

const UserInformationForm = () => {
    const { user } = useContext(UserContext);
    return (
        <Card>
            <CardBody>
                <form>
                    <p className="h5 text-center mb-4">User Information</p>
                    <div className="grey-text">
                        <InputField
                            label="Username"
                            icon="envelope"
                            type="text"
                            error="wrong"
                            success="right"
                            name="username"
                            className='mb-3'
                            defaultValue={user.name}
                            readonly
                        />
                        <InputField
                            label="First Name"
                            icon="user"
                            type="text"
                            error="wrong"
                            success="right"
                            name="firstName"
                            className='mb-3'
                            defaultValue={user.givenName}
                            readonly
                        />
                        <InputField
                            label="Last Name"
                            icon="user"
                            type="text"
                            error="wrong"
                            success="right"
                            name="lastName"
                            className='mb-3'
                            defaultValue={user.surname}
                            readonly
                        />
                        {user.isBetaParticipant == "true" &&
                        <InputField
                            label="Preferred First Name"
                            icon="user"
                            type="text"
                            error="wrong"
                            success="right"
                            name="lastName"
                            className='mb-3'
                            defaultValue=""
                            readonly
                        />}

                        <InputField
                            label="Email address"
                            icon="envelope"
                            type="email"
                            error="wrong"
                            success="right"
                            name="username"
                            className='mb-3'
                            defaultValue={user.emailaddress}
                            readonly
                        />
                        {user.isBetaParticipant == "true" &&
                        <InputField
                            label="Cell Number"
                            icon="user"
                            type="text"
                            error="wrong"
                            success="right"
                            name="cellNumber"
                            className='mb-3'
                            defaultValue=""
                            readonly
                        />
                        }


                    </div>
                </form>
            </CardBody>
        </Card>
    )
};

export default UserInformationForm;
